import { Box, Card } from '@zillow/constellation-10';

type Props = {
  children: JSX.Element;
};

export default function FullPageNoConversationsWrapper({ children }: Props): JSX.Element {
  return (
    <Box css={{ height: '100%' }}>
      <Card dividers={false} elevated={false} css={{ height: '100%' }}>
        {children}
      </Card>
    </Box>
  );
}
